import { render } from "./DeleteLocationConfirm.vue?vue&type=template&id=427cebde"
import script from "./DeleteLocationConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteLocationConfirm.vue?vue&type=script&lang=js"

import "./DeleteLocationConfirm.vue?vue&type=style&index=0&id=427cebde&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__